import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { getOrderStatusAction, handleOrderStatus } from "./actions/workorderActions";

export interface WorkOrderState {
  orderStatus: any;
}

const initialState: any = {
  orderStatus: [],
};

export const workOrderSlice = createSlice({
  name: "workorder",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // loginActionSync: handleLogin,
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      // getOrderStatusAction
      .addCase(getOrderStatusAction.fulfilled, handleOrderStatus)
      .addCase(getOrderStatusAction.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getOrderStatusAction.pending, (state) => {
        state.status = "loading";
      });
  },
});

// export const { loginActionSync } = authSlice.actions;createWorkOrderAnnouncementLaunchAction

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectOrderStatus = (state: RootState) => state.workorder.orderStatus;
